module.exports = __webpack_public_path__ + "img/box_pro_four_6.5bbe8171.jpg";